import './list.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import Switch from '../shared/switch-routes/main';

import Form from './components/form-cashback';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content payout-requests">
			<div className="container__content-title">
				<div className="container__content-title-position">
					<Switch
						intl={props.intl}
						places={[
							{ name: 'promo-codes', title: `Promo codes` },
							{ name: 'monthly-cashback', title: `Monthly cashback` }
						]}
					/>
				</div>
			</div>
		</div>
		<div className="display-flex margin-10-0-0-0">
			<div className="container__content-title display-flex">
				<div className="container__content-title-position">
					<h3 className="title margin-10-0-0-0 margin-right-5 padding-left-30">
						{props.intl('List of promo codes')}
					</h3>
				</div>
				<a className="ui-btn ui-btn-primary margin-top-5 margin-left-10" onClick={props.toggleForm}>
					{props.intl('Create new code')}
				</a>
			</div>
		</div>
		<div className="container__content promo-codes-list">
			<div className="container__content-body">
				<div className="table-container">
					<table className="simple-table">
						<thead className="simple-table__head font-roboto-medium">
							<tr>
								<th>Bonus percent</th>
								<th>Approved count</th>
								<th>Country name</th>
								<th>Actions</th>
							</tr>
						</thead>

						<tbody className="simple-table__body">
							{props.data && props.data.map((row, index) =>
								<tr key={index}>
									<td>{row.bonus_percent}</td>
									<td>{row.leads_count}</td>
									<td>{row.country_name}</td>
									<td>
										<a className="action_delete" onClick={props.remove.bind(null, row.id)}></a>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
				<Form {...props} />
			</div>
		</div>
	</Animate>
), 'contestView');

export default connect(
	state => ({
		data: selectors.getData(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		isFormOpen: selectors.getIsFormOpen(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/promo-codes/list-monthly-cashback.js